module.exports = __webpack_public_path__ + "img/botswana.63351ba4.svg";